(function($) {
    "use strict";
 $(document).ready(function() {
    console.log('ada scripts loaded');

    
    //landmarks
    setTimeout(function(){
        //weird dropdowns
        $('.theme-dropdown').each(function(){
            $(this).attr('tabindex','0');
            $(this).on('keydown', function(e){
                if(e.key === 'Enter'){
                    $(this).mouseenter();
                }
            });
            $(this).find('dt').attr('role','note');
        });

    $('h4.nosto-header').attr('aria-level','3');
        //focus indicator adjustments for images
    $('a[href]').each(function(){
        var curHtml = String($(this).html());
        var curAlt = String($(this).attr('alt'));
        if(curHtml.indexOf('<img') > -1){
            $(this).addClass('img-link');
        } else if(curHtml.indexOf('nosto-image-container') > -1){        
            $(this).removeAttr('alt').attr('aria-label',curAlt);
            $(this).addClass('img-link');
        }
    });
        var count = 1;
        $('#shopify-section-header').find('nav').each(function(){
            if(count === 1){
                $(this).attr('aria-label','Primary Menu');
                count++;
            } else {
                $(this).attr('aria-label','Mobile Menu');
            }
        });
        $('#shopify-section-theme-mini-cart').attr('aria-label','Mini Cart');
        $('#shopify-section-footer').find('.theme-footer-services').attr('aria-label','Services').attr('role','region');

        //form labels
        $('.theme-form__field').each(function(){
            var curfor = String($(this).find('label').attr('for'));
            $(this).find('input').attr('id',curfor);
        });

        $('dl').each(function(){
            var curRole = String($(this).attr('role'));
            if(curRole.indexOf('listbox') > -1){
                // $(this).removeAttr('role');
            }
           
        });


    },2500);
    //shopify-section-header
    //main
    //shopify-section-footer

 });

})(jQuery);